import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance, gql } from "@/services/httpAdapter";

export async function getMyWashoutsSidePanelTree(locationId, userId) {
	const query = gql`
		query getMyWashoutsSidePanelTree($locationId: String!, $userId: String!) {
			getMyWashoutsSidePanelTree(locationId: $locationId, userId: $userId) {
				_id
				name
				bold
				list {
					_id
					name
					status
					list {
						_id
						name
						intervalCode
						startDate
						endDate
						status
						position
						isDepartmental
						userId
						name
						commissionCycleId
						payPeriodId
						information {
							title
							variant
						}
						list {
							_id
							position
							isDepartmental
							userId
							name
							commissionCycleId
							payPeriodId
							tooltip {
								title
							}
							information {
								title
								variant
							}
						}
					}
				}
			}
		}
	`;

	const variables = {
		locationId,
		userId,
	};

	try {
		const { data } = await apiInstance.post("/graphql", { query, variables });
		return data.data?.getMyWashoutsSidePanelTree;
	} catch (err) {
		errorLogger(err);
		return null;
	}
}
